import { CharacterClass } from 'app/frontend/types/custom'
import { characterClasses } from 'app/frontend/types/custom/CharacterClass'
import { imageUrl } from '../helpers'
import { cn } from '@/lib/utils'
import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

const variants = cva('', {
  variants: {
    size: {
      small: 'w-4 h-4 border-0 min-w-4 min-h-4',
      medium: 'w-6 h-6 border min-w-6 min-h-6',
      large: 'w-8 h-8 border-2 min-w-8 min-h-8',
      custom: '',
    },
    style: {
      bordered: 'border-[#666] rounded-md',
      round: 'border-[#666] rounded-full',
      blank: '',
    },
  },
  defaultVariants: {
    size: 'medium',
    style: 'bordered',
  },
})

type Props = {
  characterClass?: CharacterClass
  className?: string
} & VariantProps<typeof variants>

const CharacterClassIcon = ({
  characterClass,
  size,
  style,
  className,
}: Props) => {
  const iconStyles = cn(variants({ size, style }), className)

  if (characterClass && characterClasses.includes(characterClass)) {
    return (
      <img
        className={iconStyles}
        src={imageUrl(`classes/${characterClass.toLowerCase()}.jpeg`)}
      />
    )
  } else {
    return <img className={iconStyles} src={imageUrl('classes/unknown.png')} />
  }
}

export default CharacterClassIcon
